import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-trash-01',
  imports: [],
  templateUrl: './trash-01.html',
  styleUrl: './trash-01.scss',
})
export class Trash01 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
